import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Sidebar from '../../components/SuperAdmin/Sidebar';
import Header from '../../components/SuperAdmin/Header';

import DashboardHome from '../../components/SuperAdmin/DashboardHome';
import ControlTower from '../../components/SuperAdmin/ControlTower';
import TaxonomyManager from '../../components/SuperAdmin/TaxonomyManager';
import IndustryProfileManager from '../../components/SuperAdmin/IndustryProfileManager';
import LegalPolicyGovernance from '../../components/SuperAdmin/LegalPolicyGovernance';
import MarketplaceControl from '../../components/SuperAdmin/MarketplaceControl';
import SecurityCompliance from '../../components/SuperAdmin/SecurityCompliance';
import AuditLogs from '../../components/SuperAdmin/AuditLogs';
import UserManagement from '../../components/SuperAdmin/UserManagement';
import SystemSettings from '../../components/SuperAdmin/SystemSettings';
import BusinessManagement from '../../components/SuperAdmin/BusinessManagement';
import PlatformIntegrationGovernance from '../../components/SuperAdmin/PlatformIntegrationGovernance';
import CommercialControlTower from '../../components/SuperAdmin/CommercialControlTower';
import TenantThreeSixty from '../../components/SuperAdmin/TenantThreeSixtyPage';
import StatusUpdatesAdmin from '../../components/SuperAdmin/StatusUpdatesAdmin';
import PartnersChannels from '../../components/SuperAdmin/PartnersChannels';

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

        <main className="flex-1 min-h-0 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
          <Routes>
            {/* INDEX ROUTE */}
            <Route index element={<DashboardHome />} />

            {/* RELATIVE ROUTES */}
            <Route path="control-tower" element={<ControlTower />} />
            <Route path="commercial" element={<CommercialControlTower />} />
            <Route path="tenants/:tenantRef/360" element={<TenantThreeSixty />} />
            <Route path="taxonomy" element={<TaxonomyManager />} />
            <Route path="industry-profiles" element={<IndustryProfileManager />} />
            {/* Z13 — the tenant SECOND governed dimension, a sibling of Industry Profiles
                rather than a child: applicability and jurisdiction vary independently. */}
            <Route path="legal-policies" element={<LegalPolicyGovernance />} />
            <Route path="marketplace" element={<MarketplaceControl />} />
            <Route path="partners" element={<PartnersChannels />} />
            <Route path="security" element={<SecurityCompliance />} />
            <Route path="integration-governance" element={<PlatformIntegrationGovernance />} />
            <Route path="audit-logs" element={<AuditLogs />} />
            <Route path="tenants" element={<BusinessManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="settings" element={<SystemSettings />} />
            <Route path="status-updates" element={<StatusUpdatesAdmin />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;